import type { ContentMasterWawiLanguageView } from '../api/generated/models/ContentMasterWawiLanguageView';
import type { ContentMasterWorkspaceDefaultLanguageView } from '../api/generated/models/ContentMasterWorkspaceDefaultLanguageView';
import { workspaceDefaultLanguageToApiValue } from './contentMasterWorkspace';

/** Value for `language` query/body: ISO639-1 (2 chars) or Wawi kSprache as string. */
export function wawiLanguageToApiValue(lang: ContentMasterWawiLanguageView): string {
  const iso = lang.iso2?.trim().toLowerCase();
  if (iso && iso.length >= 2) {
    return iso.slice(0, 2);
  }
  if (lang.kSprache != null) {
    return String(lang.kSprache);
  }
  return '';
}

export function wawiLanguageLabel(lang: ContentMasterWawiLanguageView, preferDeUi: boolean): string {
  const primary = preferDeUi ? lang.nameDe : lang.nameEn;
  if (primary?.trim()) {
    return primary.trim();
  }
  const secondary = preferDeUi ? lang.nameEn : lang.nameDe;
  if (secondary?.trim()) {
    return secondary.trim();
  }
  if (lang.iso2?.trim()) {
    return lang.iso2.trim().toUpperCase();
  }
  if (lang.kSprache != null) {
    return `kSprache ${lang.kSprache}`;
  }
  return wawiLanguageToApiValue(lang) || '?';
}

export function pickDefaultWawiLanguageCode(
  langs: ContentMasterWawiLanguageView[],
  workspaceDefault?: ContentMasterWorkspaceDefaultLanguageView | null
): string {
  const fromWorkspace = workspaceDefaultLanguageToApiValue(workspaceDefault ?? undefined);
  if (fromWorkspace) {
    return fromWorkspace;
  }
  if (!langs.length) {
    return '';
  }
  const def = langs.find((l) => l.isDefault);
  const pick = def ?? langs[0];
  return wawiLanguageToApiValue(pick);
}

export function isWawiLanguageCodeAllowed(code: string, langs: ContentMasterWawiLanguageView[]): boolean {
  if (!code.trim() || !langs.length) {
    return true;
  }
  const allowed = new Set(
    langs.map(wawiLanguageToApiValue).filter((v) => v.length > 0)
  );
  return allowed.has(code.trim());
}
